import { DialogUI } from '../../../Interface';
import { useEffect, useState } from 'react';
import { PlanTaskPage } from '../../../PlanTask/PlanTaskPage';
import { usePlanTask } from '../../../../hooks/usePlanTask';

const PlanTaskDialog = ({ open, handleClose, changed, task, submenuNames, editing, dialogData = {} }) => {
  const { taskChanged, setTaskChanged } = changed;
  const planTaskState = usePlanTask();
  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {
    if (task?.id) {
      planTaskState.setSelectedValues(task);
      if (editing) {
        planTaskState.setViewField(false);
        planTaskState.setEditButtonvisible(false);
      }
      setIsUpdate(true);
    } else {
      setIsUpdate(false);
      planTaskState.setViewField(false);
      planTaskState.setEditButtonvisible(true);
    }
  }, [task, planTaskState]);

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent={task?.name ?? submenuNames[1]}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '800px',
          },
        },
      }}
    >
      <PlanTaskPage
        dialog={{
          handleClose: handleClose,
          taskChanged: taskChanged,
          setTaskChanged: setTaskChanged,
          isUpdate: isUpdate,
          dialogData,
          editing,
        }}
        planTaskState={planTaskState}
      />
    </DialogUI>
  );
};

export default PlanTaskDialog;
